// Moved to @livingsyncs/ui (frontend split epic, Phase 5 Task 5.2 follow-up
// — needed by components/PresenceHistory.tsx, which moved). Shim kept so
// nothing importing the old path breaks — this hook still has many other
// frontend-only consumers (ShiftClockWidget, CheckInButton, etc.).
//
// Real function DECLARATIONS that call through, not reference copies or
// pass-through re-exports — see hooks/useAuth.ts's note for why (automock
// compatibility).
import * as _module from "@livingsyncs/ui";

export function useShifts(filters?: {
  facility_id?: string;
  employee_id?: string;
  start_date?: string;
  end_date?: string;
  status?: string;
}) {
  return _module.useShifts(filters);
}
export function useShift(shiftId: string) {
  return _module.useShift(shiftId);
}
export function useCreateShift() {
  return _module.useCreateShift();
}
export function useUpdateShift(shiftId: string) {
  return _module.useUpdateShift(shiftId);
}
export function useDeleteShift() {
  return _module.useDeleteShift();
}
export function useClockOut() {
  return _module.useClockOut();
}
export function useCheckIn() {
  return _module.useCheckIn();
}
export function usePresenceHistory(employeeId: string | null | undefined) {
  return _module.usePresenceHistory(employeeId);
}
export type Shift = _module.Shift;
export type ShiftInsert = _module.ShiftInsert;
export type ShiftUpdate = _module.ShiftUpdate;
